export interface Projection {
  name: string;
  bounds: {
    minX: number;
    minY: number;
    maxX: number;
    maxY: number;
  };
}

export const Projections: Record<string, Projection> = {
  'EPSG:3857': {
    name: 'EPSG:3857',
    bounds: {
      minX: -20037508.34789244,
      minY: -20037508.34789244,
      maxX: 20037508.34789244,
      maxY: 20037508.34789244,
    },
  },
  'EPSG:102100': {
    name: 'EPSG:102100',
    bounds: {
      minX: -20037508.34789244,
      minY: -20037508.34789244,
      maxX: 20037508.34789244,
      maxY: 20037508.34789244,
    },
  },
};
